import axios from "axios"
import { getTokenFromLocalStorage } from "../helpers/helpers"
import { del, get, post, put } from "./api_helper"
import {
  CALL_DELETE_ROLE,
  CALL_GET_ALL_PERMISSIONS,
  CALL_DELETE_PERMISSION,
  CALL_GET_ALL_ADMIN_USERS,
  CALL_GET_ALL_PRODUCTS,
  CALL_GET_ALL_OPERATOR_PRODUCTS,
  CALL_GET_ALL_SUPPLIERS,
  CALL_GET_ALL_PRODUCT_CATEGORIES,
  CALL_GET_ALL_PRODUCT_CHANNELS,
} from "./constants"
import { API_URL } from "../constants/constants"

axios.defaults.headers.common = {
  Authorization: `Bearer ${getTokenFromLocalStorage()}`,
}

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*"

export const axiosApi = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    common: {
      Accept: "application/json",
    },
    get: {
      "Content-Type": "application/json",
    },
    post: {
      "Content-Type": "application/json",
    },
  },
})

axiosApi.interceptors.request.use(function (config) {
  const token = localStorage.getItem("token")
  config.headers.Authorization = token ? `Bearer ${token}` : ""
  return config
})

axios.interceptors.request.use(function (config) {
  const token = `Bearer ${localStorage.getItem("token")}`
  config.headers.Authorization = token
  return config
})

// Add a response interceptor
// axiosApi.interceptors.response.use(
//   response => {
//     return response
//   },
//   error => {
//     if (error?.response?.status === 401) {
//       localStorage.removeItem("user")
//       window.location.href = "/login"
//     }
//   }
// )
export const postLogin = data => {
  return axiosApi.post(`/login`, data)
}

export const logoutApiCall = data => {
  return axiosApi.post(`/logout`, data)
}
// -----------------------------------------------ROLES CRUD-------------------------------------------------
export const getAllRolesCall = () => {
  return axiosApi.get(`/admin/roles`)
}
export const createRoleCall = role => {
  return axiosApi.post(`/admin/roles`, role)
}
export const deleteRoleCall = id => del(CALL_DELETE_ROLE + "/" + id)
export function editRoleCall(data) {
  return axiosApi.post(`admin/roles/${data.id}/update`, data)
}
export function assignRoleCall(data, roleId) {
  return axiosApi.post(`/admin/roles/${roleId}/permissions`, data)
}

// -----------------------------------------------PERMISSIONS CRUD-------------------------------------------------
export const getAllPermissionsCall = () =>
  axiosApi.get(CALL_GET_ALL_PERMISSIONS)
export const createPermissionCall = permission => {
  return axiosApi.post(`/admin/permissions`, permission)
}
export const deletePermissionCall = id => del(CALL_DELETE_PERMISSION + "/" + id)
export function editPermissionsCall(data) {
  return axiosApi.post(`admin/permissions/${data.id}/update`, data)
}

// -----------------------------------------------USERS CRUD-------------------------------------------------

export const getAllAdminUsersCall = userType =>
  axiosApi.get(`${CALL_GET_ALL_ADMIN_USERS}/${userType}`)

export const createUserCall = data => {
  return axiosApi.post(`/admin/users/create`, data)
}

export const updateUserCall = data => {
  return axiosApi.post(
    `/admin/users/${data.currentUser}/${data.user_id}/update`,
    data
  )
}

export const deleteUserCall = (type, id) => {
  return axiosApi.delete(`/admin/users/${type}/${id}/delete`)
}

// -----------------------------------------------PRODUCTS CRUD-------------------------------------------------

export const getAllProductsCall = () => axiosApi.get(CALL_GET_ALL_PRODUCTS)

export const createProductCall = data => {
  return axiosApi.post(`/admin/products`, data)
}

export function updateProductCall(data) {
  return axiosApi.post(`admin/products/${data.id}/update`, data)
}

export const deleteProductCall = id => {
  return axiosApi.delete(`/admin/products/${id}`)
}

// -----------------------------------------------Operator Products get Calls-------------------------------------------------

export const getAllOperatorProductsCall = () =>
  axiosApi.get(`${CALL_GET_ALL_OPERATOR_PRODUCTS}`)

export const getAllProductsChannelsCall = () =>
  axiosApi.get(CALL_GET_ALL_PRODUCT_CHANNELS)

export const getAllProductCategoriesCall = () =>
  axiosApi.get(CALL_GET_ALL_PRODUCT_CATEGORIES)

export const getAllSuppliersCall = () => axiosApi.get(CALL_GET_ALL_SUPPLIERS)

// -----------------------------------------------CREATE OPERATOR PRODUCT-------------------------------------------------
export const createOperatorProductCall = data => {
  return axiosApi.post(`/admin/operator-products`, data)
}

// -----------------------------------------------UPDATE OPERATOR PRODUCT-------------------------------------------------

export function updateOperatorProductCall(data) {
  return axiosApi.post(
    `admin/operator-products/${data.operator_product_id}/update`,
    data
  )
}
// -----------------------------------------------DELETE OPERATOR PRODUCT-------------------------------------------------

export const deleteOperatorProductCall = id =>
  axiosApi.delete(`admin/operator-products/${id}`)

// -----------------------------------------------SUPPLIER COMMISSIONS-------------------------------------------------
export const createSupplierCall = data => {
  return axiosApi.post(`/admin/suppliers`, data)
}

// -----------------------------------------------SUPPLIER COMMISSIONS-------------------------------------------------
export const updateSupplierCall = data => {
  return axiosApi.post(`/admin/suppliers/${data?.id}/update`, data)
}

// -----------------------------------------------RISK MANAGEMENT-------------------------------------------------
export const getAllRiskManagementSetting = () => {
  return axiosApi.get(`/admin/get-risk-management`)
}

export function updateBettingLimitCall(data) {
  return axiosApi.post(`admin/set-betting-limit`, data)
}
export const updateCahoutPercentage = (id, data) => {
  return axiosApi.put(`client/cashout-settings/${id}`, data)
}

// -----------------------------------------------ACCESS EXPIRATION-------------------------------------------------
export const getAccessExpiration = () => {
  return axiosApi.get(`get-access-expiration`)
}
export const bulkUpdateProducts = (operator_product_ids, is_active) => {
  return axiosApi.post(`admin/operator-products/bulk-update`, {
    operator_product_ids,
    is_active,
  })
}

export const setAccessExpiration = data => {
  return axiosApi.post(`admin/set-access-expiration`, data)
}

export const setRegulatory = data => {
  return axiosApi.post(`/admin/set-regulatory`, data)
}

export const setFeaturesCall = data => {
  return axiosApi.post(`/admin/set-feature`, data)
}

export const setAffiliateCall = data => {
  return axiosApi.post(`/admin/set-affiliate`, data)
}

export const getAffiliatesCall = ({ search = "", page = 1, per_page = 15 } = {}) => {
  return axiosApi.get(`/admin/affiliates`, {
    params: { search, page, per_page },
  })
}

export const getAffiliateWithdrawalsCall = ({ page = 1, per_page = 20 } = {}) => {
  return axiosApi.get(`/admin/affiliates/withdrawals`, {
    params: { page, per_page },
  })
}

export const approveAffiliateWithdrawalCall = id => {
  return axiosApi.post(`/admin/affiliates/withdrawals/${id}/approve`)
}

export const rejectAffiliateWithdrawalCall = id => {
  return axiosApi.post(`/admin/affiliates/withdrawals/${id}/reject`)
}

export const getAffiliateSummaryCall = id => {
  return axiosApi.get(`/admin/affiliates/${id}/summary`)
}

export const getAffiliateReferredUsersCall = (
  id,
  { search = "", status = "all", page = 1, per_page = 20, platform } = {}
) => {
  const params = { search, status, page, per_page }
  if (platform) params.platform = platform
  return axiosApi.get(`/admin/affiliates/${id}/referred-users`, {
    params,
  })
}

export const getReferredUserPerformanceCall = (
  referredUserId,
) => {
  return axiosApi.get(
    `/admin/affiliates/referred-users/${referredUserId}/performance`,
    {
    }
  )
}

export const getAffiliateCommissionRulesCall = id => {
  return axiosApi.get(`/admin/affiliates/${id}/commission-rules`)
}

export const createAffiliateCommissionRuleCall = (id, data) => {
  return axiosApi.post(`/admin/affiliates/${id}/commission-rules`, data)
}

export const updateAffiliateCommissionRuleCall = (id, ruleId, data) => {
  return axiosApi.put(
    `/admin/affiliates/${id}/commission-rules/${ruleId}`,
    data
  )
}

export const deleteAffiliateCommissionRuleCall = (id, ruleId) => {
  return axiosApi.delete(`/admin/affiliates/${id}/commission-rules/${ruleId}`)
}

export const getAffiliateCommissionRuleAuditLogsCall = id => {
  return axiosApi.get(`/admin/audits/affiliates/${id}/commission-rules`)
}

// -----------------------------------------------Special Markets-------------------------------------------------
export const getSpecialMarketsCall = ({ page = 1, per_page = 15 } = {}) => {
  return axiosApi.get(`/special-markets`, { params: { page, per_page } })
}

export const getSpecialMarketCall = id => {
  return axiosApi.get(`/special-markets/${id}`)
}

export const createSpecialMarketCall = data => {
  return axiosApi.post(`/special-markets`, data)
}

export const updateSpecialMarketCall = (id, data) => {
  return axiosApi.put(`/special-markets/${id}`, data)
}

export const attachSpecialMarketLeagueCall = (id, data) => {
  return axiosApi.post(`/special-markets/${id}/leagues`, data)
}

export const detachSpecialMarketLeagueCall = (id, leagueId) => {
  return axiosApi.delete(`/special-markets/${id}/leagues/${leagueId}`)
}

// -----------------------------------------------BONUSES-------------------------------------------------
export const getAllBonusesCall = () => {
  return axiosApi.get(`/admin/bonuses`)
}
export const createBonusCall = data => {
  return axiosApi.post(`/admin/bonuses`, data)
}

export function updateBonusCall(data) {
  return axiosApi.post(`/admin/bonuses/${data.id}/update`, data)
}

export const deleteBonusCall = id => {
  return axiosApi.delete(`/admin/bonuses/${id}`)
}

// -----------------------------------------------BONUS CAMPAIGNS (AFFILIATE)-------------------------------------------------
export const getBonusCampaignLookupsCall = () => {
  return axiosApi.get(`/admin/bonus-campaigns/lookups`)
}

export const getAllBonusCampaignsCall = params => {
  return axiosApi.get(`/admin/bonus-campaigns`, { params })
}

export const getBonusCampaignDetailsCall = id => {
  return axiosApi.get(`/admin/bonus-campaigns/${id}/details`)
}

export const createBonusCampaignCall = data => {
  return axiosApi.post(`/admin/bonus-campaigns`, data)
}

export const updateBonusCampaignCall = (id, data) => {
  return axiosApi.post(`/admin/bonus-campaigns/${id}/update`, data)
}

// Bounded so a slow/hanging response can't leave the row's action button
// (spinner) stuck forever — the request rejects and the UI recovers even if
// the change went through server-side.
const ACTION_TIMEOUT_MS = 20000

export const deleteBonusCampaignCall = id => {
  return axiosApi.delete(`/admin/bonus-campaigns/${id}`, { timeout: ACTION_TIMEOUT_MS })
}

export const activateBonusCampaignCall = id => {
  return axiosApi.post(`/admin/bonus-campaigns/${id}/activate`, undefined, { timeout: ACTION_TIMEOUT_MS })
}

export const pauseBonusCampaignCall = id => {
  return axiosApi.post(`/admin/bonus-campaigns/${id}/pause`, undefined, { timeout: ACTION_TIMEOUT_MS })
}

export const getBonusAwardsCall = params => {
  return axiosApi.get(`/admin/bonus-awards`, { params })
}

// -----------------------------------------------MULTIBET BONUS-------------------------------------------------
export const getAllMultiBetBonusesCall = () => {
  return axiosApi.get(`/admin/multibet-bonuses`)
}
export const createMultiBetBonusesCall = data => {
  return axiosApi.post(`/admin/multibet-bonuses`, data)
}

export function updateMultiBetBonusesCall(data) {
  return axiosApi.post(`/admin/multibet-bonuses/${data.id}/update`, data)
}

export const deleteMultiBetBonusesCall = id => {
  return axiosApi.delete(`/admin/multibet-bonuses/${id}`)
}

// -----------------------------------------------Acca7-------------------------------------------------
export const getAllAcca7Call = () => {
  return axiosApi.get(`/admin/acca7`)
}
export const createAcca7Call = data => {
  return axiosApi.post(`/admin/acca7`, data)
}

export function updateAcca7Call(data) {
  return axiosApi.post(`/admin/acca7/${data.id}/update`, data)
}

export const deleteAcca7Call = id => {
  return axiosApi.delete(`/admin/acca7/${id}`)
}

// -----------------------------------------------JACKPOTS-------------------------------------------------
export const getAllJackpotsCall = () => {
  return axiosApi.get(`/admin/jackpots`)
}
export const createJackpotCall = data => {
  return axiosApi.post(`/admin/jackpots`, data)
}

export function updateJackpotCall(data) {
  return axiosApi.post(`/admin/jackpots/${data.id}/update`, data)
}

export const deleteJackpotCall = id => {
  return axiosApi.delete(`/admin/jackpots/${id}`)
}

// -----------------------------------------------EVENTS-------------------------------------------------
export const getAllEventsCall = () => {
  return axiosApi.get(`/admin/events`)
}

// -----------------------------------------------PROMOTIONS-------------------------------------------------
export const getAllPromotionsCall = () => {
  return axiosApi.get(`/admin/promotions`)
}
export const createPromotionCall = data => {
  return axiosApi.post(`/admin/promotions`, data)
}

export function updatePromotionCall(data, id) {
  return axiosApi.post(`/admin/promotions/${id}/update`, data)
}

export const deletePromotionCall = id => {
  return axiosApi.delete(`/admin/promotions/${id}`)
}

// -----------------------------------------------STATIC PAGES-------------------------------------------------
export const getAllStaticPagesCall = () => {
  return axiosApi.get(`/admin/static-pages`)
}
export const createStaticPageCall = data => {
  return axiosApi.post(`/admin/static-pages`, data)
}

export function updateStaticPageCall(data) {
  return axiosApi.post(`/admin/static-pages/${data.id}/update`, data)
}

export const deleteStaticPageCall = id => {
  return axiosApi.delete(`/admin/static-pages/${id}`)
}

// -----------------------------------------------SHOPS-------------------------------------------------
export const getAllShopsCall = () => {
  return axiosApi.get(`/admin/shops`)
}
export const createShopCall = data => {
  return axiosApi.post(`/admin/shops`, data)
}

export function updateShopCall(data, id) {
  return axiosApi.post(`/admin/shops/${id}/update`, data)
}

export const deleteShopCall = id => {
  return axiosApi.delete(`/admin/shops/${id}`)
}
// -----------------------------------------------Sports-------------------------------------------------
export const getSports = (sb, eb) => {
  axiosApi
    .get("/admin/sports")
    .then(res => sb(res))
    .catch(e => eb(e))
}

export const changeSportStatus = (id, sb, eb) => {
  axiosApi
    .post(`/admin/sports/${id}/update-status`)
    .then(res => {
      sb(res)
    })
    .catch(e => {
      eb(e)
    })
}

export function assignMarketCall(data, sportId) {
  return axiosApi.post(`/admin/sports/${sportId}/markets`, data)
}

// -----------------------------------------------Locations-------------------------------------------------
export const getLocations = (sb, eb) => {
  axiosApi
    .get("/admin/locations")
    .then(res => sb(res))
    .catch(e => eb(e))
}

export const changeLocationStatus = (id, sb, eb) => {
  axiosApi
    .post(`/admin/locations/${id}/update-status`)
    .then(res => {
      sb(res)
    })
    .catch(e => {
      eb(e)
    })
}

// -----------------------------------------------Leagues-------------------------------------------------
export const getLeagues = (sb, eb) => {
  axiosApi
    .get("/admin/leagues")
    .then(res => sb(res))
    .catch(e => eb(e))
}

export const changeLeaguesStatus = (id, sb, eb) => {
  axiosApi
    .post(`/admin/leagues/${id}/update-status`)
    .then(res => {
      sb(res)
    })
    .catch(e => {
      eb(e)
    })
}
export const changeLeaguesTopStatus = (id, sb, eb) => {
  axiosApi
    .post(`/admin/leagues/${id}/update-top-status`)
    .then(res => {
      sb(res)
    })
    .catch(e => {
      eb(e)
    })
}

export const updateLeagueOneOrTwoUpFeatures = data => {
  return axiosApi.post(`/one-up-two-up/league/update`, data)
}

// -----------------------------------------------Campaigns-------------------------------------------------

export const getCampaigns = (sb, eb) => {
  axiosApi
    .get("/admin/campaigns")
    .then(res => sb(res))
    .catch(e => eb(e))
}
export const getAllCampaignsCall = () => {
  return axiosApi.get(`/admin/campaigns`)
}
export const createCampaignCall = data => {
  return axiosApi.post(`/admin/campaigns`, data)
}

export function updateCampaignCall(data, id) {
  console.log(id)
  return axiosApi.post(`/admin/campaigns/${id}/update`, data)
}

export const deleteCampaignCall = id => {
  return axiosApi.delete(`/admin/campaigns/${id}`)
}
// -----------------------------------------------Markets-------------------------------------------------
export const getMarkets = (sb, eb) => {
  axiosApi
    .get("/admin/markets")
    .then(res => sb(res))
    .catch(e => eb(e))
}

export const createMarketCall = market => {
  return axiosApi.post(`/admin/markets`, market)
}

export const deleteMarketCall = id => {
  return axiosApi.delete(`/admin/markets/${id}`)
}

export function editMarketsCall(data) {
  return axiosApi.post(`admin/markets/${data.id}/update`, data)
}

// -----------------------------------------------CASHIER-------------------------------------------------
export const getAllCashiersCall = () => {
  return axiosApi.get(`/admin/cashiers`)
}
export const createCashierCall = data => {
  return axiosApi.post(`/admin/cashiers`, data)
}

export function updateCashierCall(data, id) {
  return axiosApi.post(`/admin/cashiers/${id}/update`, data)
}

export const deleteCashierCall = id => {
  return axiosApi.delete(`/admin/cashiers/${id}`)
}

export const setSportMarkets = (id, data, sb, eb) => {
  return axiosApi
    .post(`/admin/sports/${id}/markets`, data)
    .then(res => {
      sb()
    })
    .catch(e => {
      eb()
    })
}

export const getEndUsersCount = () => {
  return axiosApi.get(`/admin/end-user-count`)
}

export const getEndUser = q => {
  return axiosApi.get(`/admin/find-end-user`, {
    params: {
      q: q,
    },
  })
}

// -----------------------------------------------BANNERS-------------------------------------------------
export const getAllBannersCall = () => {
  return axiosApi.get(`/admin/banners`)
}
export const createBannerCall = data => {
  return axiosApi.post(`/admin/banners`, data)
}

export function updateBannerCall(data, id) {
  return axiosApi.post(`/admin/banners/${id}/update`, data)
}

export const deleteBannerCall = id => {
  return axiosApi.delete(`/admin/banners/${id}`)
}
export const getUserPerformance = (id, sc, ec, from = null, to = null) => {
  var today = new Date()
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()
  return axiosApi
    .get(
      `/admin/get-user-performance/${id}?from=${from ?? date}&to=${to ?? date}`
    )
    .then(res => {
      sc(res.data)
    })
    .catch(e => {
      ec()
    })
}

export const getUserTickets = (
  id,
  sc,
  ec,
  from = null,
  to = null,
  type = "all",
  item = "All"
) => {
  var today = new Date()
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()
  return axiosApi
    .get(
      `/admin/get-user-tickets/${id}?from=${from ?? date}&to=${
        to ?? date
      }&type=${type}&item=${item}`
    )
    .then(res => {
      sc(res.data)
    })
    .catch(e => {
      ec()
    })
}

export const getAffiliatePerformance = async (
  id,
  sc,
  ec,
  from = null,
  to = null
) => {
  var today = new Date()
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()
  return axiosApi
    .get(
      `/admin/referral-conversions/showByReferrerCode/${id}?from=${
        from ?? date
      }&to=${to ?? date}`
    )
    .then(res => {
      sc(res.data)
    })
    .catch(e => {
      ec()
    })
}

export const getDashboardStats = (sc, ec) => {
  return axiosApi
    .get(`/admin/dashboard/stats`)
    .then(res => {
      sc(res.data)
    })
    .catch(e => {
      ec()
    })
}

export const getSummaryData = (sc, ec, payload) => {
  return axiosApi
    .post(`/admin/summaryData`, payload)
    .then(res => {
      sc(res.data)
    })
    .catch(e => {
      ec(e)
    })
}

// -----------------------------------------------END USERS-------------------------------------------------

export const depositEndUserCash = (id, loggedInUser, data) => {
  return axiosApi.post(`/admin/end-users/${id}/deposit/${loggedInUser} `, data)
}
export const depositCashierCash = (id, loggedInUser, data) => {
  return axiosApi.post(`/admin/cashier/${id}/deposit/${loggedInUser} `, data)
}

export const withdrawalEndUserCash = (id, loggedInUser, data) => {
  return axiosApi.post(
    `/admin/end-users/${id}/withdrawal/${loggedInUser} `,
    data
  )
}
export const withdrawalCashierCash = (id, loggedInUser, data) => {
  return axiosApi.post(`/admin/cashier/${id}/withdrawal/${loggedInUser} `, data)
}

export const collectSendBonus = (id, loggedInUser, data, type) => {
  return axiosApi.post(
    `/admin/end-users/${id}/bonus/${loggedInUser}/${type} `,
    data
  )
}

export const storeNotesData = data => {
  return axiosApi.post(`/admin/note/store`, data)
}

export const getAllSportsCall = () => {
  return axiosApi.get(`/v4/sports`)
}
export const updateUserStatus = (id, status) => {
  return axiosApi.get(`/admin/end-users/${id}/update-status/${status}`)
}

export const updateUserWithdrawStatus = (id, status) => {
  return axiosApi.get(`/admin/end-users/${id}/update-withdraw-status/${status}`)
}

export const getFixtureBySportIdCall = (
  url,
  sportId,
  date1,
  date2,
  market = "1x2",
  search
) => {
  if (url && !search) {
    return axiosApi.get(
      `${url}&date1=${date1}&date2=${date2}&market=${market}&search=${search}`
    )
  } else {
    return axiosApi.get(
      `/v4/all/sports/${sportId}/fixtures?date1=${date1}&date2=${date2}&market=${market}&search=${search}`
    )
  }
}
// --------------------------------------------analystics---------------------------------------------

export const getAnalyticsData = (sc, ec, payload) => {
  return axiosApi
    .post(`/admin/analytics`, payload)
    .then(res => {
      sc(res.data)
    })
    .catch(e => {
      ec(e)
    })
}
